import BackToBanner from 'components/back-to-banner';
import React from 'react';
import { useNavigation } from 'react-navi';
import { toQuerystring } from 'utils/navigation-utils';
import { BackToDashboardProps } from './back-to-dashboard-props';

/**
 * Navigates to the dashboard page.
 */
export const BackToDashboard: React.FC<BackToDashboardProps> = () => {
  const navigation = useNavigation();
  const { query } = navigation.getCurrentValue().url;
  const params = {
    userType: query.userType,
    db: query.db,
    traits: query.scenario || query.traits, // TODO: change this to be query.traits
  };
  const href = `/search/dashboard${toQuerystring(params)}`;

  return (
    <BackToBanner
      href={href}
    >
      Back to dashboard
    </BackToBanner>
  );
};
